export const getRootURL = () => `${window.location.origin}/${window.location.pathname.split("/")[1]}`;

export const getConnectionURL = id => `${getRootURL()}/dl/instructor/serviceCatalog.html?bookmark=connection/${id}`;

export const getScheduleConnectionURL = id => `${getConnectionURL(id)}/schedule`;

export const getServiceURL = id => `${getRootURL()}/dl/instructor/serviceCatalog.html?bookmark=service/${id}`;

export const getScheduleServiceURL = id => `${getServiceURL(id)}/schedule`;
